module.exports = __webpack_public_path__ + "static/file/2018_TodoMath_BacktoSchool_Flyer.4327b17.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/2018_TodoMath_BacktoSchool_Flyer.pdf
// module id = 5Gta
// module chunks = 18